import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { CountryCodeJsonFile, CountryCodeJsonFileItem } from '../models/hrm-lookup.models';
import { ILocalizedStringDto } from '../models/localized-string.model';
import { BaseHrmLookupClient } from './base-hrm-lookup.client';

@Injectable({
  providedIn: 'root',
})
export class CountryCodesClient extends BaseHrmLookupClient<CountryCodeLookupItemModel> {
  protected override FILE_PATH = 'generated/country-codes.json';

  private readonly locale = inject(LOCALE_ID);

  getCountryCodes(): Observable<CountryCodeLookupItemModel[]> {
    return this.getCachedOrFetch().pipe(map((countryCodes) => this.sortCountryCodes(countryCodes)));
  }

  protected getLocalizedName(item: CountryCodeJsonFileItem): string {
    if (this.locale === 'nb-NO') {
      return item.n;
    } else {
      return item.e;
    }
  }

  protected override mapFileToModel(data: CountryCodeJsonFile): CountryCodeLookupItemModel[] {
    const result: CountryCodeLookupItemModel[] = [];

    for (const [code, item] of Object.entries(data.countryCodes)) {
      const mappedItem: CountryCodeLookupItemModel = {
        code,
        name: this.getLocalizedName(item),
        localizedName: {
          english: item.e,
          norwegian: item.n,
        },
      };

      if (item.f) {
        mappedItem.activeFrom = new Date(item.f);
      }
      if (item.t) {
        mappedItem.activeTo = new Date(item.t);
      }

      result.push(mappedItem);
    }

    return result;
  }

  private sortCountryCodes(
    countryCodes: CountryCodeLookupItemModel[],
  ): CountryCodeLookupItemModel[] {
    return countryCodes.sort((a, b) => a.name.localeCompare(b.name));
  }
}

export type CountryCodeLookupItemModel = {
  code: string;
  name: string;
  localizedName: ILocalizedStringDto;
  activeFrom?: Date;
  activeTo?: Date;
};
